import React, { useState } from "react";
import logo from "../../assets/images/logo.png";
import login_img from "../../assets/images/login-img.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate, Link } from "react-router-dom";
import ApiService from "../../services/ApiService.js";
import { toast } from "react-toastify";
import AuthTalentGuard from "../../components/AuthTalentGuard.jsx";
import { useTranslation } from "react-i18next";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

const TalentLogin = () => {
  const [showSignup, setShowSignup] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const clearCompanyData = () => {
    const companyData = localStorage.getItem("company");
    if (companyData) {
      localStorage.removeItem("company");
      localStorage.removeItem("token");
      // Optional: Show message to user
      console.log("Previous company session cleared");
    }
  };
   const { t, i18n } = useTranslation();
     const isRTL = i18n.language === 'ar';

  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(false);
  // const basePath = process.env.REACT_APP_BASE_PATH;
  const [showPassword, setShowPassword] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoader(true);

    try {
      clearCompanyData();
      const response = await ApiService.request({
        method: "POST",
        url: `login`,
        data: formData,
      });
      const data = response.data;
      console.log("loginlogin", data);
      if (data.status) {
        toast.success(data.message);

        const talent = data.data.talent;
        const authToken = data.data.auth_token;

        const userData = { ...talent, auth_token: authToken };
        localStorage.setItem("user", JSON.stringify(userData));
        navigate("/talent/dashboard");
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      // toast.error("Login failed!");
      setIsLoader(false);
    }
  };

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
<AuthTalentGuard>
  <Header />
  <div 
    className="inter-font main-bg min-vh-100 d-flex flex-column justify-content-center align-items-center position-relative w-100 px-3"
    style={{ direction: isRTL ? "rtl" : "ltr" }}
  >
    {/* <Link 
      to={"/"} 
      className="inter-font position-absolute top-0"
      style={{ 
        [isRTL ? "right" : "left"]: "0", 
        marginTop: "1rem", 
        [isRTL ? "marginRight" : "marginLeft"]: "1rem" 
      }}
    >
      <img
        src={logo}
        alt="Logo"
        style={{ height: "50px", maxWidth: "100%" }}
      />
    </Link> */}

    <div
      className="inter-font container talent-login px-0"
      style={{ maxWidth: "850px" }}
    >
      <div className="inter-font row justify-content-center">
        <div className="inter-font col-lg-12">
          <div className="inter-font row g-0 shadow-lg rounded-4 overflow-hidden">
            {/* Left Image */}
            <div className="inter-font col-md-6 d-none d-md-block">
              <img
                src={login_img}
                className="inter-font w-100 h-100 object-fit-cover"
                alt="Login visual"
                style={{ height: "550px", objectFit: "cover" }}
              />
            </div>

            {/* Right Form */}
            <div className="inter-font col-12 col-md-6 bg-white p-4 p-md-5">
              <form onSubmit={handleSubmit}>
                <div className="inter-font text-center text-md-start">
                  <h3
                    className="inter-font fw-bold mb-2"
                    style={{ fontSize: "25px", marginTop: "30px", textAlign: isRTL ? "right" : "left" }}
                  >
                    {t("t_d_text72")} {/* Sign in to your account */}
                  </h3>
                  <p className="inter-font text-muted mb-4" style={{ textAlign: isRTL ? "right" : "left" }}>
                    {t("t_d_text73")} {/* Login in to talent */}
                  </p>
                </div>

                <div className="inter-font mb-3">
                  <label className="inter-font fs-6 mb-1" style={{ textAlign: isRTL ? "right" : "left" }}>
                    {t("c_ff_text30")} {/* Email */} <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className="inter-font form-control p-3 rounded-2"
                    name="email"
                    placeholder={t("c_ff_text3")}
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    style={{ backgroundColor: "#f8f8f8", textAlign: isRTL ? "right" : "left" }}
                    dir="ltr"
                  />
                </div>
                <div className="inter-font mb-3 w-100">
                  <label style={{ textAlign: isRTL ? "right" : "left" }}>
                    {t("c_ff_text2")} {/* Password */} <span className="text-danger">*</span>
                  </label>
                  <div className="inter-font position-relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      className="inter-font form-control p-3 rounded-2"
                      value={formData.password}
                      placeholder={t("new_text_17")}
                      onChange={handleInputChange}
                      required
                      style={{ backgroundColor: "#f8f8f8", textAlign: isRTL ? "right" : "left" }}
                      dir="ltr"
                    />
                    <span
                      onClick={togglePasswordVisibility}
                      style={{
                        position: "absolute",
                        [isRTL ? "left" : "right"]: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#aaa",
                      }}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                  <div className="mt-3" style={{ textAlign: isRTL ? "right" : "left" }}>
                    <Link 
                      to={"/talent/forgot-password"}   
                      style={{
                        color: "#E46A56",
                        background: "none",
                        fontSize:"14px"
                      }} 
                      className="text-decoration-underline"
                    >
                      {t("c_ff_text5")} {/* Forgot Password? */}
                    </Link>
                  </div>
                </div>

                <div className="inter-font mt-4">
                  <button
                    type="submit"
                    className="inter-font btn btn-base px-5 sofia-font"
                    disabled={isLoader}
                    style={{
                      backgroundColor: "#E26A52",
                      color: "#fff",
                      border: "none"
                    }}
                  >
                    {isLoader ? t("new_text_18") : t("c_login_btn")} {/* Please wait... / Login */}
                  </button>
                </div>

                <p
                  className="inter-font mt-3 sofia-font"
                  style={{ fontSize: "14px", textAlign: isRTL ? "right" : "left" }}
                >
                  {t("c_login_info")} {/* Don't have an account? */}
                  <Link 
                    to="/talent/register"
                    className="inter-font text-decoration-underline"
                    style={{ 
                      cursor: "pointer", 
                      color: "#FF6237",
                      marginLeft: isRTL ? "0" : "4px",
                      marginRight: isRTL ? "4px" : "0"
                    }}
                    onClick={() => setShowSignup(true)}
                  >
                    {t("h_s4_c2_title")} {/* Sign Up */}
                  </Link>
                </p>

                <p
                  className="inter-font small text-start mt-3"
                  style={{ 
                    color: "rgba(0, 0, 0, 0.4)", 
                    fontSize: "12px",
                    textAlign: isRTL ? "right" : "left"
                  }}
                >
                  {t("t_d_text74")} {/* By joining, you agree to the Nahham */}
                  <Link to="/terms-and-conditions">
                    <strong
                      className="inter-font mx-1 sofia-font"
                      style={{ color: "#FF6237" }}
                    >
                      {t("t_d_text75")} {/* Terms of Service */}
                    </strong>
                  </Link>
                  {t("t_d_text76")} {/* and to occasionally receive emails from us. Please read our */}
                  <Link
                    to="/privacy-policy"
                    className="inter-font mx-1 sofia-font"
                    style={{ color: "#FF6237" }}
                  >
                    <strong>
                      {t("t_d_text77")} {/* Privacy Policy */}
                    </strong>
                  </Link>
                  {t("t_d_text78")} {/* to learn how we use your personal data. */}
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<Footer />
</AuthTalentGuard>
  );
};

export default TalentLogin;
